
define('text!templates/app/member/setting/personal/personal-content.html',[],function () { return '<div class="panel-body" id="setting">\n    <div id="setting-payments"></div>\n    <div id="setting-personal-info"></div>\n    <div id="setting-preferences"></div>\n</div>\n';});

